import React from 'react'
import AARPGames from './AARPGames'
import BuildTeam from './BuildTeam'
import RemoteOnboardingExecutiveTraining from './RemoteOnboardingExecutiveTraining'
import VirtualWorlds from './VirtualWorlds'
// import VRAssessment from './VRAssessment'
import VRDevelopmentBanner from './VRDevelopmentBanner'
import VRGameDevelopment from './VRGameDevelopment'
import VRHealthCare from './VRHealthCare'
import VRTraining from './VRTraining'
import VRWorksExample from './VRWorksExample'

const VRDevelopment = () => {
  document.title = "Paracosma | VR Development"
  return (
    <>
        <div className="main-body">
            <VRDevelopmentBanner />
            <VRWorksExample />
            <VRTraining />
            <BuildTeam />
            <VRHealthCare />
            {/* <VRAssessment /> */}
            <RemoteOnboardingExecutiveTraining />
            <VirtualWorlds />
            <VRGameDevelopment />
            <AARPGames />
        </div>
    </>
  )
}

export default VRDevelopment
